module.exports = __webpack_public_path__ + "img/photo-file.69f3d863.svg";